<template>
  <div class="profile-page first_page" >
    <loading-block v-if="isload==false" :loading="!isload"/>
    <section class="section" v-if="isload">
      <div class="container-fluid">
        <div class="col-12 col-md-6 col-lg-5">
          <UserCard   :user="developer" />
        </div>
        <div class="row mt-3 ml-3 mb-3">
          <router-link tag="a" v-if="count_works>0" class="btn" :to="{name: 'developer', params: { username: this.developer.username }}">Все работы
          </router-link>
          <router-link tag="a" v-if="count_reviews>0" class="btn " :to="{name: 'reviewpage', params: { username: this.developer.username }}">Отзывы
          </router-link>
          <router-link tag="a" class="btn btn-active" v-if="developer.isshop && developer.isshop==1 && developer.shop_setting.status && developer.shop_setting.status=='on'" :to="{name: 'developer_catalog', params: { username: this.developer.username }}">Каталог</router-link>
        </div>
        <div class="row card mb-3   section_gray_bg" v-if="developer.shop_setting.title">
          <div class="card-body">
            <h2 >{{ developer.shop_setting.title}}</h2>
            <p v-if="developer.shop_setting.description">{{ developer.shop_setting.description}}</p>
          </div>

        </div>
        <div class="row m-3">

          <div class="card alert " v-if="is_error">
            <p>{{ error_message }}</p>
          </div>
        </div>
          <div class="row col-12" v-if="items.length>0">

            <div class="col-6 col-sm-6 col-lg-2 col-md-3 card   item_card_mini  "  v-for="(item,item_index) in items" :key="item_index" >
              <div class="item_data section_gray_bg">
              <router-link class="" :to="{name: 'shop_item_id', params: {id:item.last_id }}" tag="a" ><img :src="item.photos[0]" class="card-img-top" alt="..."></router-link>

                <router-link class=" " :to="{name: 'shop_item_id', params: {id:item.last_id }}" tag="a" > <h5 class="card-title">{{ item.title}}</h5></router-link>
                <h5 class="card-title">{{ item.price}} {{ item.currency}}</h5>

<!--                <div class="row mb-2">-->
<!--                  <div class="col-4">-->
<!--                    <a class="btn" @click="changeType(item_index,'-')" >-</a>-->
<!--                  </div>-->
<!--                  <div class="col-4">-->
<!--                    <h4>{{ item.count}}</h4>-->
<!--                  </div>-->

<!--                  <div class="col-4">-->
<!--                    <a class="btn"  @click="changeType(item_index,'+')"  >+</a>-->

<!--                  </div>-->
<!--                </div>-->

                <a href="#" class="btn" @click="addToCart(item_index)">В корзину</a>
                </div>
            </div>

          </div>


      </div>
    </section>


  </div>
</template>
<script>
import {eventBus} from "@/main";
import Vue from "vue";
import Api from "@/models/Api";
import Editorjsrender from "@/models/Editorjsrender.vue";
import UserCard from "@/components/Custom/UserCard";
import LoadingBlock from "@/components/Custom/LoadingBlock";

var Avatar = require('vue-avatar')

export default {
  name: "UserShop",
  data() {
    return {
      'more_btn': '<button  class="btn">Посмотреть работу</button>',
      "isload": false,
      "items":[],
      'developer': {},
      'work': {},
      'image_url': null,
      "is_error":false,
      "error_message":"",
      "count_arr":{},
      'item':{},
      'count_reviews':0,
      'count_works':0,

    }
  },
  mounted() {
    var app = this;
    Api.loadDeveloperItems(this.$route.params.username, function (developer_data) {
      app.image_url = Vue.config.IMAGE_URL;
      app.developer = developer_data.developer;
      app.count_reviews=developer_data.count_reviews;
      app.count_works=developer_data.count_works;
      var i=0;
      if(developer_data.items.length>0){
        while(developer_data.items[i]){
          developer_data.items[i].count=1;

          i++;
        }
      }
      app.items=developer_data.items;


      app.isload = true;
    },function(){
      app.$router.push({name:'404'});
    });


  },
  methods: {
    changeType(last_id,type){
      var app=this;
      var count_arr=app.count_arr;
      var count=parseInt(app.items[last_id].count);

      if(count>0 && type=="-"){
        count=count-1;

      }else if(type=="+"){
        count=count+1;
      }

      app.isload=false;
      //    Vue.delete(app.cart, 'last_id_'+last_id);
      app.items[last_id].count=0;
      app.items[last_id].count=count;


      app.isload=true;
    },
    changeCount(index_last_id){
      var count=1;
      var app=this;
      if(app.count_arr["last_id_"+index_last_id]>0){
        count=app.count_arr["last_id_"+index_last_id];
      }
      app.count_arr["last_id_"+index_last_id]=count;

    },
    addToCart(index_key){

      var app=this;
      app.item=app.items[index_key];

      if(app.item.count<1){
        app.item.count=1;
      }


      var item={};
      item.last_id=app.item.last_id;
      item.title=app.item.title;
      item.photos=app.item.photos;
      item.price=app.item.price;
      item.custom_price=app.item.price;
      item.currency=app.item.currency;
      item.options=app.item.options;
      item.custom_options=[];
      item.count=app.item.count;
      item.total_price=parseInt(item.price)*item.count;



      // var query_obj={};
      // if(localStorage.getItem('api_token')){
      //   query_obj.rand_code=localStorage.getItem('api_token');
      // }

      app.is_error=false;
      Api.addToCart(item,function(){
        Api.syncCart();
      },function (err){

        app.is_error=true;
        app.error_message=err;
      });



      // app.custom_options=[];

      //  app.custom_price=parseInt(app.item.price);

    },
  },
  components: {
    'UserCard':UserCard,
    'editorjsrender': Editorjsrender, 'avatar': Avatar.Avatar, LoadingBlock
  }
};
</script>
<style>
</style>
